export const BASE_API_URL =
  window.location.origin.includes('localhost') || window.location.origin.includes('127.0.0.1')
    ? 'https://127.0.0.1:5001/api'
    : `${window.location.origin}/api`

/**
 * This value is used to remove the contain of an attribute.
 * The backend will receive `null` instead.
 */
export const NONE_VALUE = 'NONE'

/**
 * Object that contains all the API path for the HTTP requests.
 * Those paths are used by :
 * @see ../middlewares/Api.js
 */
export const apiPaths = {
  // == ENVIRONMENT -----------------------------------------------------------------------------------
  ENV_LIST: '/environment', // Method: GET (list of account objects)

  // == ACCOUNTS -----------------------------------------------------------------------------------
  ACCOUNT_LIST: '/users', // Method: GET (list of account objects)
  ACCOUNT_CREATE: '/users', // Method: POST
  ACCOUNT_GET: '/users/:uid', // Method: GET (one account object)
  ACCOUNT_CURRENT_GET: '/users/current', // Method: GET (one account object)
  ACCOUNT_UPDATE: '/users/:uid', // Method: PUT
  ACCOUNT_DELETE: '/users/:uid', // Method: DELETE
  ACCOUNT_RIGHTS_GET: '/users/rights', // Method: GET (one account_right object)
  // ==============================================================================================

  // == PROJECTS -----------------------------------------------------------------------------------
  PROJECT_LIST: '/projects', // Method: GET (list of project objects)
  PROJECT_GET: '/projects/:pid', // Method: GET (one project object)
  PROJECT_CREATE: '/projects', // Method: POST
  PROJECT_UPDATE: '/projects/:pid', // Method: PUT
  PROJECT_DELETE: '/projects/:pid', // Method: DELETE
  PROJECTS_IMPORT_GLOBAL: '/projects/:pid/globals', // Method: POST
  // ==============================================================================================

  // ==== PROJECT's ATTRIBUTES ---------------------------------------------------------------------
  // ==== PROJECT ATTRIBUTE  >  VARIABLES
  PROJECT_VARIABLE_LIST: '/projects/:pid/variables', // Method: GET (list of variable objects)
  PROJECT_VARIABLE_CREATE: '/projects/:pid/variables', // Method: POST
  PROJECT_VARIABLE_UPDATE: '/projects/:pid/variables/:vid', // Method: PUT
  PROJECT_VARIABLE_DELETE: '/projects/:pid/variables/:vid', // Method: DELETE
  // ==== PROJECT ATTRIBUTE  >  RESOURCES
  PROJECT_RESOURCE_LIST: '/projects/:pid/resources', // Method: GET (list of resource objects)
  PROJECT_RESOURCE_CREATE: '/projects/:pid/resources', // Method: POST
  PROJECT_RESOURCE_UPDATE: '/projects/:pid/resources/:rid', // Method: PUT
  PROJECT_RESOURCE_DELETE: '/projects/:pid/resources/:rid', // Method: DELETE
  // ==== PROJECT ATTRIBUTE  >  PRODUCTS
  PROJECT_PRODUCT_LIST: '/projects/:pid/products', // Method: GET (list of product objects)
  PROJECT_PRODUCT_CREATE: '/projects/:pid/products', // Method: POST
  PROJECT_PRODUCT_UPDATE: '/projects/:pid/products/:did', // Method: PUT
  PROJECT_PRODUCT_DELETE: '/projects/:pid/products/:did', // Method: DELETE
  // ==== PROJECT ATTRIBUTE  >  LOCATIONS
  PROJECT_LOCATION_LIST: '/projects/:pid/locations', // Method: GET (list of location objects)
  PROJECT_LOCATION_CREATE: '/projects/:pid/locations', // Method: POST
  PROJECT_LOCATION_UPDATE: '/projects/:pid/locations/:lid', // Method: PUT
  PROJECT_LOCATION_DELETE: '/projects/:pid/locations/:lid', // Method: DELETE
  // ==== PROJECT ATTRIBUTE  >  WEATHERS
  PROJECT_WEATHER_LIST: '/projects/:pid/weather_data', // Method: GET (list of weather objects)
  PROJECT_WEATHER_CREATE: '/projects/:pid/weather_data', // Method: POST
  PROJECT_WEATHER_UPDATE: '/projects/:pid/weather_data/:wid', // Method: PUT
  PROJECT_WEATHER_DELETE: '/projects/:pid/weather_data/:wid', // Method: DELETE
  // ==== PROJECT ATTRIBUTE  >  PARAMETERS
  PROJECT_PARAMETER_LIST: '/projects/:pid/parameters', // Method: GET (list of parameter objects)
  PROJECT_PARAMETER_CREATE: '/projects/:pid/parameters', // Method: POST
  PROJECT_PARAMETER_UPDATE: '/projects/:pid/parameters/:mid', // Method: PUT
  PROJECT_PARAMETER_DELETE: '/projects/:pid/parameters/:mid', // Method: DELETE
  // ==============================================================================================

  // == PROJECT's SCENARIOS ---------------------------------------------------------------------------------
  SCENARIO_LIST: '/projects/:pid/scenarios', // Method: GET (list of scenario objects)
  SCENARIO_GET: '/projects/:pid/scenarios/:sid', // Method: GET (one scenario object)
  SCENARIO_CREATE: '/projects/:pid/scenarios', // Method: POST
  SCENARIO_UPDATE: '/projects/:pid/scenarios/:sid', // Method: PUT
  SCENARIO_DELETE: '/projects/:pid/scenarios/:sid', // Method: DELETE
  SCENARIO_CLONE: '/projects/:pid/scenarios/:sid/clone', // Method: POST
  SCENARIO_IMPORT: '/projects/:pid/scenarios/:sid/import', // Method: POST
  SCENARIOS_IMPORT_GLOBAL: '/projects/:pid/scenarios/:sid/globals', // Method: POST

  // ==== SCENARIO's ATTRIBUTES ---------------------------------------------------------------------
  // ==== SCENARIO ATTRIBUTE  >  VARIABLES
  SCENARIO_VARIABLE_LIST: '/projects/:pid/scenarios/:sid/variables', // Method: GET (list of variable objects)
  SCENARIO_VARIABLE_CREATE: '/projects/:pid/scenarios/:sid/variables', // Method: POST
  SCENARIO_VARIABLE_UPDATE: '/projects/:pid/scenarios/:sid/variables/:vid', // Method: PUT
  SCENARIO_VARIABLE_DELETE: '/projects/:pid/scenarios/:sid/variables/:vid', // Method: DELETE
  // ==== SCENARIO ATTRIBUTE  >  RESOURCES
  SCENARIO_RESOURCE_LIST: '/projects/:pid/scenarios/:sid/resources', // Method: GET (list of resource objects)
  SCENARIO_RESOURCE_CREATE: '/projects/:pid/scenarios/:sid/resources', // Method: POST
  SCENARIO_RESOURCE_UPDATE: '/projects/:pid/scenarios/:sid/resources/:rid', // Method: PUT
  SCENARIO_RESOURCE_DELETE: '/projects/:pid/scenarios/:sid/resources/:rid', // Method: DELETE
  // ==== SCENARIO ATTRIBUTE  >  PRODUCTS
  SCENARIO_PRODUCT_LIST: '/projects/:pid/scenarios/:sid/products', // Method: GET (list of product objects)
  SCENARIO_PRODUCT_CREATE: '/projects/:pid/scenarios/:sid/products', // Method: POST
  SCENARIO_PRODUCT_UPDATE: '/projects/:pid/scenarios/:sid/products/:did', // Method: PUT
  SCENARIO_PRODUCT_DELETE: '/projects/:pid/scenarios/:sid/products/:did', // Method: DELETE
  // ==== SCENARIO ATTRIBUTE  >  LOCATIONS
  SCENARIO_LOCATION_LIST: '/projects/:pid/scenarios/:sid/locations', // Method: GET (list of location objects)
  SCENARIO_LOCATION_CREATE: '/projects/:pid/scenarios/:sid/locations', // Method: POST
  SCENARIO_LOCATION_UPDATE: '/projects/:pid/scenarios/:sid/locations/:lid', // Method: PUT
  SCENARIO_LOCATION_DELETE: '/projects/:pid/scenarios/:sid/locations/:lid', // Method: DELETE
  // ==== SCENARIO ATTRIBUTE  >  WEATHERS
  SCENARIO_WEATHER_DATA_LIST: '/projects/:pid/scenarios/:sid/weather_data', // Method: GET (list of weather objects)
  SCENARIO_WEATHER_DATA_CREATE: '/projects/:pid/scenarios/:sid/weather_data', // Method: POST
  SCENARIO_WEATHER_DATA_UPDATE: '/projects/:pid/scenarios/:sid/weather_data/:wid', // Method: PUT
  SCENARIO_WEATHER_DATA_DELETE: '/projects/:pid/scenarios/:sid/weather_data/:wid', // Method: DELETE
  // ==== SCENARIO ATTRIBUTE  >  PARAMETERS
  SCENARIO_PARAMETER_LIST: '/projects/:pid/scenarios/:sid/parameters', // Method: GET (list of parameter objects)
  SCENARIO_PARAMETER_CREATE: '/projects/:pid/scenarios/:sid/parameters', // Method: POST
  SCENARIO_PARAMETER_UPDATE: '/projects/:pid/scenarios/:sid/parameters/:mid', // Method: PUT
  SCENARIO_PARAMETER_DELETE: '/projects/:pid/scenarios/:sid/parameters/:mid', // Method: DELETE
  // ==============================================================================================

  // ==== PROJECT's SENARIO's FLOW GROUPS
  FLOW_GROUP_LIST: '/projects/:pid/scenarios/:sid/flow_groups', // Method: GET (list of flow group objects)
  FLOW_GROUP_GET: '/projects/:pid/scenarios/:sid/flow_groups/:fid', // Method: GET (one object)
  FLOW_GROUP_CREATE: '/projects/:pid/scenarios/:sid/flow_groups', // Method: POST
  FLOW_GROUP_UPDATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid', // Method: PUT
  FLOW_GROUP_DELETE: '/projects/:pid/scenarios/:sid/flow_groups/:fid', // Method: DELETE
  // ==============================================================================================

  // ==== PROJECT's SENARIO's FLOW GROUP'S ACTIONS =================================================
  // ==== PROJECT's SENARIO's FLOW GROUP's START
  FLOW_START_UPDATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/flows/:oid', // Method: PUT
  // ==== PROJECT's SENARIO's FLOW GROUP's TASK
  FLOW_TASK_LIST: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks', // Method: GET (list of task objects)
  FLOW_TASK_UPDATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid', // Method: PUT
  FLOW_TASK_ASSIGN: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/assign_task', // Method: PUT
  // ----- TASK's INTERACTION's  >  Variables
  FLOW_TASK_INTERACTION_VARIABLE_LIST: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/variables', // Method: GET
  FLOW_TASK_INTERACTION_VARIABLE_CREATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/variables', // Method: POST
  FLOW_TASK_INTERACTION_VARIABLE_UPDATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/variables/:vid', // Method: PUT
  FLOW_TASK_INTERACTION_VARIABLE_DELETE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/variables/:vid', // Method: DELETE
  // ----- TASK's INTERACTION's  >  Resources
  FLOW_TASK_INTERACTION_RESOURCE_LIST: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/resources', // Method: GET
  FLOW_TASK_INTERACTION_RESOURCE_CREATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/resources', // Method: POST
  FLOW_TASK_INTERACTION_RESOURCE_UPDATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/resources/:rid', // Method: PUT
  FLOW_TASK_INTERACTION_RESOURCE_DELETE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/resources/:rid', // Method: DELETE
  // ----- TASK's INTERACTION's  >  Checks
  FLOW_TASK_INTERACTION_CHECK_CREATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/checks', // Method: POST
  FLOW_TASK_INTERACTION_CHECK_UPDATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/checks/:kid', // Method: PUT
  FLOW_TASK_INTERACTION_CHECK_DELETE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/tasks/:tid/checks/:kid', // Method: DELETE
  // ==== PROJECT's SENARIO's FLOW GROUP's CONDITION
  FLOW_CONDITION_LIST: '/projects/:pid/scenarios/:sid/flow_groups/:fid/conditions', // Method: GET (list of condition objects)
  FLOW_CONDITION_UPDATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/conditions/:cid', // Method: PUT
  // ======== PROJECT's SENARIO's FLOW GROUP's CONDITION  >  CHECK
  FLOW_CONDITION_CHECK_LIST: '/projects/:pid/scenarios/:sid/flow_groups/:fid/conditions/:cid/checks', // Method: GET (list of condition objects)
  FLOW_CONDITION_CHECK_CREATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/conditions/:cid/checks', // Method: POST
  FLOW_CONDITION_CHECK_UPDATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/conditions/:cid/checks/:kid', // Method: PUT
  FLOW_CONDITION_CHECK_DELETE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/conditions/:cid/checks/:kid', // Method: DELETE
  // ==== PROJECT's SENARIO's FLOW GROUP's END
  FLOW_END_LIST: '/projects/:pid/scenarios/:sid/flow_groups/:fid/end', // Method: GET (list of end objects)
  FLOW_END_UPDATE: '/projects/:pid/scenarios/:sid/flow_groups/:fid/end/:eid', // Method: PUT
  // ==============================================================================================

  // == PROJECT's SCENARIO's SIMULATIONS --------------------------------------------------------------------------------
  SIMULATION_LIST: '/projects/:pid/scenarios/:sid/simulations', // Method: GET (list of parameter objects)
  SIMULATION_CREATE: '/projects/:pid/scenarios/:sid/simulations', // Method: POST
  SIMULATION_CANCEL: '/projects/:pid/scenarios/:sid/simulations/:iid', // Method: PUT
  SIMULATION_DELETE: '/projects/:pid/scenarios/:sid/simulations/:iid', // Method: DELETE
  SIMULATION_DOWNLOAD_LOGS: '/projects/:pid/scenarios/:sid/simulations/:iid/download-logs', // Method: GET
  // ==============================================================================================

  // == GLOBAL's ATTRIBUTES -----------------------------------------------------------------------
  // == GLOBAL ATTRIBUTE  >  VARIABLES
  GLOBAL_VARIABLE_LIST: '/variables', // Method: GET (list of variable objects)
  GLOBAL_VARIABLE_CREATE: '/variables', // Method: POST
  GLOBAL_VARIABLE_UPDATE: '/variables/:vid', // Method: PUT
  GLOBAL_VARIABLE_DELETE: '/variables/:vid', // Method: DELETE
  // == GLOBAL ATTRIBUTE  >  RESOURCES
  GLOBAL_RESOURCE_LIST: '/resources', // Method: GET (list of resource objects)
  GLOBAL_RESOURCE_CREATE: '/resources', // Method: POST
  GLOBAL_RESOURCE_UPDATE: '/resources/:rid', // Method: PUT
  GLOBAL_RESOURCE_DELETE: '/resources/:rid', // Method: DELETE
  // == GLOBAL ATTRIBUTE  >  PRODUCTS
  GLOBAL_PRODUCT_LIST: '/products', // Method: GET (list of product objects)
  GLOBAL_PRODUCT_CREATE: '/products', // Method: POST
  GLOBAL_PRODUCT_UPDATE: '/products/:did', // Method: PUT
  GLOBAL_PRODUCT_DELETE: '/products/:did', // Method: DELETE
  // == GLOBAL ATTRIBUTE  >  LOCATIONS
  GLOBAL_LOCATION_LIST: '/locations', // Method: GET (list of location objects)
  GLOBAL_LOCATION_CREATE: '/locations', // Method: POST
  GLOBAL_LOCATION_UPDATE: '/locations/:lid', // Method: PUT
  GLOBAL_LOCATION_DELETE: '/locations/:lid', // Method: DELETE
  // == GLOBAL ATTRIBUTE  >  WEATHER_DATA
  GLOBAL_WEATHER_DATA_LIST: '/weather_data', // Method: GET (list of weather objects)
  GLOBAL_WEATHER_DATA_CREATE: '/weather_data', // Method: POST
  GLOBAL_WEATHER_DATA_UPDATE: '/weather_data/:wid', // Method: PUT
  GLOBAL_WEATHER_DATA_DELETE: '/weather_data/:wid', // Method: DELETE
  GLOBAL_WEATHER_DATA_DOWNLOAD: '/weather_data/:wid/download', // Method: GET
  // == GLOBAL ATTRIBUTE  >  PARAMETERS
  GLOBAL_PARAMETER_LIST: '/parameters', // Method: GET (list of parameter objects)
  GLOBAL_PARAMETER_CREATE: '/parameters', // Method: POST
  GLOBAL_PARAMETER_UPDATE: '/parameters/:mid', // Method: PUT
  GLOBAL_PARAMETER_DELETE: '/parameters/:mid', // Method: DELETE
  // ==============================================================================================

  // == ALPHA FACTORS -----------------------------------------------------------------------------
  ALPHA_FACTOR_LIST: '/alpha_factors'
  // ==============================================================================================
}

/**
 * Get a path route from its path schema and its placeholders to be replaced.
 *
 * Ex:
 *  - apiPaths.TEST = '/my/complete/:id/path/to/:hello'
 *  - getApiPath(apiPaths.TEST, {id: 5, hello: 'world'}) →  '/my/complete/5/path/to/world'
 *
 * @param {string} path value get from the `apiPaths` constant, Ex: apiPaths.PROJECT_CREATE
 * @param {object} keyVal value of the placeholders to change from the path, Ex: { pid: 5 })
 * @returns {string}
 */
export const getApiPath = (path, keyVal) => {
  Object.keys(keyVal).forEach((key) => (path = (path || '').replace(new RegExp(`:${key}`), keyVal[key] || '')))
  return path
}
